import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={12} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/ban07" target="_blank" rel="noreferrer"><img src={navIcon1} alt="" /></a>
              <a href="https://discordapp.com/users/718452711493992500" target="_blank" rel="noreferrer"><img src={navIcon2} alt="" /></a>
              <a href="https://www.behance.net/ban07" target="_blank" rel="noreferrer"><img src={navIcon3} alt="" /></a>
            </div>
            <p>Copyright 2023. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}